import { render } from "./PaymentLinks.vue?vue&type=template&id=044d1031"
import script from "./PaymentLinks.vue?vue&type=script&lang=js"
export * from "./PaymentLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__